import Protected from '../Protected';
import './GetHelp.css';

export const GetHelp = (props) => {

    return (
        <div id="need-help" title=''>
            <Protected returnNull={true} internal={[1]}>
                <h5>Submit Feedback & Get Help</h5>
                <h6>1. Feature Requests & Non-Critical Bugs</h6>
                <p>Use our new centralized form for all feature requests, improvements, and bug reports:</p>
                <a
                    href="https://forms.gle/noDNJnH7ssb7WaP1A"
                    target="_blank" 
                    rel="noopener noreferrer"
                >
                    AudioMate - Feature Request & Bug Submission form
                </a>
                <p>Once submitted and reviewed, you can see your request alongside all others here:</p>
                <a href="https://docs.google.com/spreadsheets/d/1h-OWSCZOFUW28N2GW6RtDCnwRB49ULU7TI6uMWoE7Jo/edit?usp=sharing"
                    target="_blank" 
                    rel="noopener noreferrer"
                >
                    AudioMate Public Request Tracker
                </a>
                <h6>2. Urgent/Blocking Issues</h6>
                <p>If you are currently blocked and require immediate assistance, please contact us directly via email:</p>
            </Protected>
            <Protected returnNull={true} internal={[0]} returnIfNoData={props?.fromLoggin} >
                <h5>Need Support?</h5>
                <Protected returnNull={true} internal={[0]}>
                    <p>For technical assistance, bug reports, or feature requests, please contact our support team directly via email:</p>
                </Protected>
                <Protected returnNull={true} internal={[1]} returnIfNoData={true} >
                    <p>For technical assistance, please contact our support team directly via email:</p>
                </Protected>
            </Protected>
            <a href="mailto:audiomate.support@keywordsstudios.com">
                audiomate.support@keywordsstudios.com
            </a>
        </div>
    )
};